import React from 'react'

// material ui
import Typography from '@mui/material/Typography'

const PricingNotice = props => {
  const { product, camperSession } = props

  const { buc } = camperSession || {}
  const { retail } = product || {}

  if (!retail) {
    return null
  }

  if (buc) {
    return (
      <Typography mb={2} fontStyle='italic'>
        *Note: These retail passes may be purchased as an optional add-on to
        your Bright Horizons Back-Up Care passes. You can add additional Back-Up
        Care passes by requesting care through the Back-Up Care app or website.
      </Typography>
    )
  }

  return (
    <Typography mb={2} fontStyle='italic'>
      If you have guest pass codes, enter "0" below and click "Redeem Guest
      Passes" to add the codes to your shopping cart.
    </Typography>
  )
}

export default PricingNotice
